module.exports = __webpack_public_path__ + "static/img/img-main-sam@3x.0e7f9c1d.png";